import { Component } from '@angular/core';
import { CarouselModule, CarouselResponsiveOptions } from 'primeng/carousel';
import { TagModule } from 'primeng/tag';
import { RatingModule } from 'primeng/rating';
import { FormsModule } from '@angular/forms';

interface Review {
  name: string
  studio: string
  gameName: string
  reviewText: string
  rating: number
}

@Component({
  selector: 'app-home-testimonials',
  standalone: true,
  imports: [
    CarouselModule,
    TagModule,
    RatingModule,
    FormsModule
  ],
  templateUrl: './home-testimonials.component.html',
  styleUrl: './home-testimonials.component.scss'
})
export class HomeTestimonialsComponent {
  reviews: Review[] = [
     {
      name: "Shawnyg",
      studio: "Police Roleplay Community",
      gameName: "Emergency Response: Liberty County",
      reviewText: "We've been a long time user of Ro-Render as it is the easiest, fastest, and best looking solution available on the market today for creating a top-down view of our game map. The renders can show more than enough detail to allow our users to expand the map view and know their location at any time. Seeing its progression throughout the years has been amazing as I've personally witnessed its speed increase beyond what I would've imagined for the detail it provides...",
      rating: 5
    },
    {
      name: "Luke",
      studio: "Central Roleplay Community",
      gameName: "Maple County",
      reviewText: "RoRender has been a great asset in providing a way to create an interactive minimap for our users at CRP Maple County. The quality of the software creates realistic maps so that you do not have to waste resources on creating them with viewports or finding an artist to draw it for you. I really encourage the use of this software to all creators planning to make games such as RPGs or police roleplay games just like ours!",
      rating: 5
    },
    {
      name: "Bizarre",
      studio: "Vextol Interactive",
      gameName: "Coastal Ridge County",
      reviewText: "At Vextol Interactive, we are always on the lookout for powerful tools to enhance our game development workflow, and Ro-Render has proven to be an exceptional asset. It provides a seamless platform for creating, editing, and integrating an interactive minimap system into our games, meeting all our needs effortlessly.",
      rating: 5
    },
    {
      name: "kni0002",
      studio: "Shipping Studios",
      gameName: "Shipping Lanes",
      reviewText: "Without RoRender Shipping Lanes would have no in-game minimap. The map in Shipping Lanes is pushing the limits of how large a map can be on Roblox being 200k x 200k studs, and RoRender easily copes with it while still generating high-quality renders. I’ve been using RoRender for several years and the improvements since then have been astounding, making the plugin easy and convenient to use, not to mention the massive speed increases in rendering which Shipping Lanes has hugely benefited from.",
      rating: 5
    },
    {
      name: "KinderDev",
      studio: "Typical Developers",
      gameName: "Oaklands",
      reviewText: "RoRender has been an outstanding tool for creating maps for our game, Oaklands. We have used it for minimaps, community-shared maps, and more. Its ease of use and high-quality top-down renders make it a wonderful choice for anyone in need of detailed world maps",
      rating: 5
    },
    {
      name: "MrGamingZB",
      studio: "Springr Studios",
      gameName: "Boulder County: First Responders",
      reviewText: "I spent a long time trying to figure out how to create a realistic, high-quality map for my Roblox game. After finding RoRender online, all my needs were satisfied and exceeded. RoRender offers exceedingly high quality renders, free of charge. Their software is easy to use and the documentation online is very helpful.",
      rating: 5
    },
  ]
  responsiveOptions: CarouselResponsiveOptions[] = [
    //{
    //  breakpoint: "10000px",
    //  numVisible: 5,
    //  numScroll: 1
    //},
    {
      breakpoint: "2400px",
      numVisible: 4,
      numScroll: 1
    },
    {
      breakpoint: "1800px",
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: "1500px",
      numVisible: 2,
      numScroll: 2
    },
    {
      breakpoint: "1100px",
      numVisible: 1,
      numScroll: 1
    },
  ]
}
